import { render } from "./TribologyTab.vue?vue&type=template&id=4e077503&scoped=true"
import script from "./TribologyTab.vue?vue&type=script&lang=js"
export * from "./TribologyTab.vue?vue&type=script&lang=js"

import "./TribologyTab.vue?vue&type=style&index=0&id=4e077503&scoped=true&lang=css"

import exportComponent from "/home/adelaplace/PycharmProjects/pumping_tool_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e077503"]])

export default __exports__